import {
  DISCOVER_CREATE_CHARACTER_ARTWORK_CARDS,
  DISCOVER_CREATE_CHARACTER_ARTWORK_GRADIENT_ANGLE_DEG,
  DISCOVER_CREATE_CHARACTER_ARTWORK_GRADIENT_MID_STOP,
} from "@next-platform/client-common-core";
import React, { type CSSProperties } from "react";

import { cn } from "@/utils";

const PERCENT = 100;
const MID_STOP_PERCENT = DISCOVER_CREATE_CHARACTER_ARTWORK_GRADIENT_MID_STOP * PERCENT;

const CARD_LAYOUT_CLASS_NAMES: Record<string, string> = {
  left: "left-0 top-[40px] size-[110px] -rotate-12 rounded-[20px]",
  center: "left-[85px] top-0 z-[2] size-[140px] rounded-3xl",
  right: "left-[170px] top-[40px] size-[110px] rotate-12 rounded-[20px]",
};

type ArtworkCard = {
  id: string;
  style: CSSProperties;
  spark: string;
  initial: string;
  className: string;
};

const CARDS: readonly ArtworkCard[] = DISCOVER_CREATE_CHARACTER_ARTWORK_CARDS.map((card) => ({
  id: card.id,
  style: {
    background: `linear-gradient(${DISCOVER_CREATE_CHARACTER_ARTWORK_GRADIENT_ANGLE_DEG}deg, ${card.colors[0]} 0%, ${card.colors[1]} ${MID_STOP_PERCENT}%, ${card.colors[2]} ${PERCENT}%)`,
  },
  spark: card.spark,
  initial: card.initial,
  className: CARD_LAYOUT_CLASS_NAMES[card.id],
}));

const ROOT_CLASS_NAME = "relative mx-auto h-[200px] w-[280px]";
const CARD_CLASS_NAME = "absolute grid place-items-center overflow-hidden shadow-[0_18px_36px_rgba(0,0,0,0.55)]";
const SPARK_CLASS_NAME = "absolute right-2 top-2 text-base leading-none text-white/40";
const INITIAL_CLASS_NAME = "text-[36px] font-black leading-none tracking-[-1.44px] text-white/[0.22]";

const DiscoverCreateCharacterArtwork = () => (
  <div data-testid="DiscoverCreateCharacterBlockView-Artwork" aria-hidden="true" className={ROOT_CLASS_NAME}>
    {CARDS.map((card) => (
      <div key={card.id} className={cn(CARD_CLASS_NAME, card.className)} style={card.style}>
        <span className={SPARK_CLASS_NAME}>{card.spark}</span>
        <span className={INITIAL_CLASS_NAME}>{card.initial}</span>
      </div>
    ))}
  </div>
);

export default React.memo(DiscoverCreateCharacterArtwork);
